<script setup lang="ts">
import { MicOff, VideoOff } from "lucide-vue-next"
import { Button } from "@/components/ui/button"

defineProps<{
  isOpen: boolean
  micDenied: boolean
  cameraDenied: boolean
}>()

const emit = defineEmits<{
  (e: 'recheck'): void
}>()
</script>

<template>
  <div v-if="isOpen"
       class="absolute inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
    <div class="bg-card border rounded-xl w-[440px] max-w-[90%] p-5 shadow-2xl">
      <div class="flex items-center gap-2 mb-3">
        <MicOff v-if="micDenied" class="size-5 text-destructive" />
        <VideoOff v-if="cameraDenied" class="size-5 text-destructive" />
        <h3 class="text-lg font-semibold">Нет доступа к {{ micDenied && cameraDenied ? 'микрофону и камере' : micDenied ? 'микрофону' : 'камере' }}</h3>
      </div>
      <p class="text-sm text-muted-foreground mb-4">
        Приложение не может использовать
        {{ micDenied && cameraDenied ? 'микрофон и камеру' : micDenied ? 'микрофон' : 'камеру' }}
        — доступ заблокирован в настройках системы. Без микрофона вас не будут слышать в
        голосовом канале. Откройте
        <span class="font-medium text-foreground">Системные настройки → Конфиденциальность и безопасность → {{ micDenied ? 'Микрофон' : 'Камера' }}</span>
        и включите разрешение для этого приложения, затем нажмите «Проверить снова».
      </p>
      <div class="flex justify-end gap-2">
        <Button variant="secondary" @click="emit('recheck')">Проверить снова</Button>
      </div>
    </div>
  </div>
</template>
